<template>
    <App title="Asset Bundles">
        <div class="mx-auto py-4 px-3 container">
            <div class="d-flex align-items-center justify-content-between mb-4">
                <div>
                    <h2 class="fw-bold text-dark mb-1">Asset Bundles</h2>
                    <p class="text-muted small mb-0">Records of engine assignments to financiers</p>
                </div>
            </div>

            <div class="bg-white border rounded-2 p-3 shadow-sm">
                <Datatable :options="options" />
            </div>
        </div>
    </App>
</template>

<script lang="ts">
import App from '@/vue/templates/App.vue'
import Datatable from '@/vue/components/Datatable.vue'
import { Component, Vue, toNative } from 'vue-facing-decorator'
import { CellRender } from '@/vue/utils/Datatable'

@Component({
    components: { App, Datatable },
})
class BundleGroup extends Vue {
    get options() {
        return {
            ajax: {
                url: this.route('bundle.ajax.table'),
                method: 'POST',
            },
            columns: [
                {
                    data: 'reference',
                    title: 'Reference',
                    render: (data: string, type: any, row: any) => {
                        return `<a href="${this.route('bundle.page.single', row.id)}" class="text-primary fw-bold text-decoration-none">${data}</a>`
                    }
                },
                {
                    data: 'financier',
                    title: 'Financier',
                },
                {
                    data: 'source',
                    title: 'Source',
                    render: (data: string, type: any, row: any) => {
                        return `<span>${data} <small class="text-muted">(${row.source_type})</small></span>`
                    }
                },
                {
                    data: 'quantity',
                    title: 'Items',
                },
                {
                    data: 'admin',
                    title: 'Created By',
                },
                {
                    data: 'created_at',
                    title: 'Date',
                    render: CellRender.date(),
                },
                {
                    title: 'Action',
                    render: (data: any, type: any, row: any) => {
                        return `<a href="${this.route('bundle.page.single', row.id)}" class="btn btn-xs btn-outline-primary">View Receipt</a>`
                    }
                }
            ],
        }
    }
}

export default toNative(BundleGroup)
</script>